<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-8"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-1"
                                            @click="searchListing"
                                            :disabled="!status.list && loading"
                                            :title="$t('label.refresh')"
                                            v-b-tooltip:hover
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            right
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Platform
                                                </label>
                                                <multiselect
                                                    v-model="platformFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="platformDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Method
                                                </label>
                                                <multiselect
                                                    v-model="methodFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="methodDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Success
                                                </label>
                                                <multiselect
                                                    v-model="successFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="successDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    User
                                                </label>
                                                <multiselect
                                                    v-model="userFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="userDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <!-- <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Exclude Request Logs
                                                </label>
                                                <multiselect
                                                    v-model="excludeRequestLogsFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="excludeRequestLogsDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div> -->
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(user)="data">
                                    <span>{{ data.item.user ? data.item.user.firstName + ' ' + data.item.user.lastName : '--' }}</span>
                                </template>
                                <template #cell(platform)="data">
                                    <b-badge
                                        :variant="data.item.pathPrefix == 'api' ? 'success' : data.item.pathPrefix == 'app-api' ? 'primary' : 'secondary'"
                                    >
                                        {{ data.item.pathPrefix == 'api' ? 'PORTAL' : data.item.pathPrefix == 'app-api' ? 'APP' : 'N/A' }}
                                    </b-badge>
                                </template>
                                <template #cell(method)="data">
                                    <b-badge :variant="getMethodVariant(data.item.method)">{{ data.item.method || '--' }}</b-badge>
                                </template>
                                <template #cell(url)="data">
                                    <span>
                                        {{ data.item.url ? data.item.url.length > 60 ? data.item.url.substring(0, 60) + '...' : data.item.url : '--' }}
                                    </span>
                                </template>
                                <template #cell(success)="data">
                                    <b-badge :variant="data.item.success ? 'success' : 'danger'">
                                        {{ data.item.success ? $t('label.yes') : $t('label.no') }}
                                    </b-badge>
                                </template>
                                <template #cell(statusCode)="data">
                                    <span>{{ data.item.statusCode ? data.item.statusCode : '--' }}</span>
                                </template>
                                <template #cell(userAgent)="data">
                                    <span>
                                        {{ data.item.userAgent ? data.item.userAgent.length > 30 ? data.item.userAgent.substring(0, 30) + '...' : data.item.userAgent : '--' }}
                                    </span>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        :class="[data.item.errorLog ? 'text-danger' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.errorLog')"
                                        v-on:click="data.item.errorLog ? openErrorLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-console font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        :class="['ml-1', data.item.activityLog ? 'text-success' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.activityLog')"
                                        v-on:click="data.item.activityLog ? openActivityLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-file-clock-outline font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        :class="['ml-1', data.item.communicationLog ? 'text-warning' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.communicationLog')"
                                        v-on:click="data.item.communicationLog ? openCommunicationLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-message-text-outline font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.detail')"
                                        v-on:click="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-eye font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="request-log-form"
            :title="$t('label.viewX', [$t('module.requestLog')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <RequestLogForm
                    :requestLog="requestLog"
                    @done="closeForm"
                    ref="requestLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="request-error-log-form"
            :title="$t('label.viewX', [$t('module.errorLog')])"
            @hidden="closeErrorLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <ErrorLogForm
                    :errorLog="errorLog"
                    @done="closeErrorLog"
                    ref="errorLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="request-activity-log-form"
            :title="$t('label.viewX', [$t('module.activityLog')])"
            @hidden="closeActivityLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <ActivityLogForm
                    :activityLog="activityLog"
                    @done="closeActivityLog"
                    ref="activityLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="request-communication-log-form"
            :title="$t('label.viewX', [$t('module.activityLog')])"
            @hidden="closeActivityLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <CommunicationLogForm
                    :communicationLog="communicationLog"
                    @done="closeCommunicationLog"
                    ref="communicationLogForm"
                />
            </b-container>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { requestLogMethods, lookupMethods } from "@/state/api";
import { REQUEST_LOG_MODULE } from "@/state/api/requestLog.state";
import RequestLogForm from "@/views/pages/admin/diagnostic/requestLog/requestLogForm";
import ErrorLogForm from "@/views/pages/admin/diagnostic/errorLog/errorLogForm";
import ActivityLogForm from "@/views/pages/admin/diagnostic/activityLog/activityLogForm";
import CommunicationLogForm from "@/views/pages/admin/diagnostic/communicationLog/communicationLogForm";

export default {
    components: { Multiselect, RequestLogForm, ErrorLogForm, ActivityLogForm, CommunicationLogForm },
    async created() {
        await this.lookupUser({});

        sessionHelper.clearSearch(SESSION.REQUEST_LOG_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            platformDdl: [
                ddlHelper.getOptionAll(),
                { value: 'api', text: 'Portal' },
                { value: 'app-api', text: 'App' },
                { value: 'web', text: 'N/A' },
            ],
            methodDdl: [
                ddlHelper.getOptionAll(),
                { value: 'GET', text: 'GET' },
                { value: 'POST', text: 'POST' },
                { value: 'PUT', text: 'PUT' },
                { value: 'PATCH', text: 'PATCH' },
                { value: 'DELETE', text: 'DELETE' },
            ],
            methodFilter: ddlHelper.getOptionAll(),
            platformFilter: ddlHelper.getOptionAll(),
            successDdl: [
                ddlHelper.getOptionAll(),
                { value: 1, text: i18n.t('label.yes') },
                { value: 0, text: i18n.t('label.no') },
            ],
            // excludeRequestLogsDdl: [
            //     { value: 1, text: i18n.t('label.yes') },
            //     { value: 0, text: i18n.t('label.no') },
            // ],
            successFilter: ddlHelper.getOptionAll(),
            userFilter: null,
            // excludeRequestLogsFilter: { value: 1, text: i18n.t('label.yes') },
            fields: [
                { key: 'createdAt', label: i18n.t("label.createdAt"), sortable: true, class: 'text-nowrap' },
                { key: 'user', label: 'User', sortable: true, class: 'text-nowrap' },
                { key: 'platform', label: 'Platform', sortable: false, class: 'text-nowrap' },
                { key: 'method', label: 'Method', sortable: false, class: 'text-nowrap' },
                { key: 'url', label: 'URL', sortable: true, class: '' },
                { key: 'success', label: 'Success', sortable: false, class: 'text-nowrap' },
                { key: 'statusCode', label: 'Status Code', sortable: false, class: 'text-nowrap' },
                { key: 'userAgent', label: 'User Agent', sortable: false, class: '' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            requestLog: this.defaultRequestLog(),
            errorLog: this.defaultErrorLog(),
            activityLog: this.defaultActivityLog(),
            communicationLog: this.defaultCommunicationLog(),
            loading: true,
        };
    },
    methods: {
        ...requestLogMethods,
        ...lookupMethods,
        defaultErrorLog() {
            return {
                uuid: "",
                level: "",
                exceptionClass: "",
                message: "",
                exceptionCode: "",
                sourceFile: "",
                sourceLine: "",
                stackTrace: "",
                previous_exception: "",
                performance: null,
                hostname: "",
                context: "",
                createdAt: "",
                updatedAt: "",
                user: null,
            };
        },
        defaultRequestLog() {
            return {
                uuid: "",
                method: "",
                path: "",
                files: null,
                requestPayload: null,
                responsePayload: null,
                ip: "",
                url: "",
                scheme: "",
                host: "",
                port: "",
                cookies: null,
                userAgent: "",
                statusCode: "",
                success: false,
                performance: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                errorLog: null,
            };
        },
        defaultActivityLog() {
            return {
                uuid: "",
                log_name: "",
                event: "",
                description: "",
                subjectType: "",
                subjectId: "",
                causerType: "",
                properties: null,
                performance: null,
                oldValues: null,
                newValues: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                requestLog: null,
            };
        },
        defaultCommunicationLog() {
            return {
                uuid: "",
                method: "",
                purpose: "",
                from: "",
                to: "",
                cc: "",
                bcc: "",
                payload: null,
                subject: "",
                isUsed: false,
                isActive: false,
                createdAt: "",
                createdBy: "",
                updatedAt: "",
                updatedBy: "",
                deletedAt: "",
                deletedBy: "",
                user: null,
                requestLog: null,
            };
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.REQUEST_LOG_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.REQUEST_LOG_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    searchValue: "",
                    searchArray: [],
                };
            }

            // if (this.excludeRequestLogsFilter?.value) this.searchCriteria.excludeRequestLogs = this.excludeRequestLogsFilter.value;

            this.getRequestLogList(this.searchCriteria);
        },
        getRequestLogList(filter) {
            this.getAllRequestLog({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.REQUEST_LOG_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.REQUEST_LOG_SEARCH);
            filter.pageNumber = pageNumber;
            this.getRequestLogList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.platformFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.pathPrefix;
            else if (this.platformFilter?.value)
                this.searchCriteria.pathPrefix = this.platformFilter.value;

            if (this.methodFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.method;
            else if (this.methodFilter?.value)
                this.searchCriteria.method = this.methodFilter.value;

            if (this.successFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.success;
            else if (this.successFilter?.value == 0 || this.successFilter?.value == 1)
                this.searchCriteria.success = this.successFilter.value;

            if (this.userFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.user;
            else if (this.userFilter?.value)
                this.searchCriteria.user = this.userFilter.value;

            // if (this.excludeRequestLogsFilter?.value == SHARED.DEFAULT_ALL_VALUE)
            //     delete this.searchCriteria.excludeRequestLogs;
            // else if (this.excludeRequestLogsFilter?.value == 0 || this.excludeRequestLogsFilter?.value == 1)
            //     this.searchCriteria.excludeRequestLogs = this.excludeRequestLogsFilter.value;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getRequestLogList(this.searchCriteria);
        },
        openForm(data) {
            if (data?.uuid) {
                this.requestLog = {
                    ...this.defaultRequestLog(),
                    ...data,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('request-log-form');
            });
        },
        closeForm() {
            this.requestLog = this.defaultRequestLog();
            this.$bvModal.hide('request-log-form');
        },
        openErrorLog(data) {
            if (data?.errorLog) {
                this.errorLog = {
                    ...this.defaultErrorLog(),
                    ...data.errorLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('request-error-log-form');
            });
        },
        openActivityLog(data) {
            if (data?.activityLog) {
                this.activityLog = {
                    ...this.defaultActivityLog(),
                    ...data.activityLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('request-activity-log-form');
            });
        },
        openCommunicationLog(data) {
            if (data?.communicationLog) {
                this.communicationLog = {
                    ...this.defaultCommunicationLog(),
                    ...data.communicationLog,
                };
            }  
            this.$nextTick(() => {
                this.$bvModal.show('request-communication-log-form');
            });
        },
        closeErrorLog() {
            this.errorLog = this.defaultErrorLog();
            this.$bvModal.hide('request-error-log-form');
        },
        closeActivityLog() {
            this.activityLog = this.defaultActivityLog();
            this.$bvModal.hide('request-activity-log-form');
        },
        closeCommunicationLog() {
            this.communicationLog = this.defaultCommunicationLog();
            this.$bvModal.hide('communication-log-form');
        },
        getMethodVariant(method) {
            if(method == 'GET') return 'info';
            if(method == 'POST') return 'success';
            if(method == 'PUT') return 'warning';
            if(method == 'PATCH') return 'primary';
            if(method == 'DELETE') return 'danger';
            return 'secondary';
        },
    },
    computed: {
        ...mapState(REQUEST_LOG_MODULE, ['status']),
        userDdl() {
            return [
                ddlHelper.getOptionAll(),
                ...this.$store.state.api.lookup.userDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.requestLog.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.requestLog.list.pagination.total || 0;
        },
    },
}
</script>
